import { RouteConfig } from 'vue-router';
import { TARGET_ENTITIES } from '@/utils/constants';
const AssetOwnerModule = () =>
  import(
    /* webpackChunkName: 'investment' */ '@/modules/assetOwner/AssetOwnerModule.vue'
  );

const SchemePage = () =>
  import(
    /* webpackChunkName: 'investment' */ '@/modules/assetOwner/pages/SchemePage.vue'
  );

const SchemeInformationComponent = () =>
  import(
    /* webpackChunkName: 'investment' */
    '@/modules/assetOwner/components/SchemeInformation/SchemeInformationComponent.vue'
  );

const SchemeInformationPage = () =>
  import(
    /* webpackChunkName: 'investment' */ '@/modules/assetOwner/pages/SchemeInformationPage.vue'
  );

const FundInformationPage = () =>
  import(
    /* webpackChunkName: 'investment' */ '@/modules/assetOwner/pages/FundInformationPage.vue'
  );

export const AssetOwnerModuleRoutes: RouteConfig[] = [
  {
    path: 'manage',
    component: AssetOwnerModule,
    props: true,
    name: 'dashboard.organisation.clients',
    children: [
      {
        path: 'clients',
        component: SchemePage,
        props: true,
        name: 'dashboard.organisation.investments.clients',
        meta: {
          title: 'Pension Schemes',
          middlewares: {
            canAccessEntity: TARGET_ENTITIES.pensionSchemes
          }
        }
      },
      {
        path: ':investmentId/funds',
        component: SchemeInformationPage,
        props: true,
        children: [
          {
            path: '',
            component: SchemeInformationComponent,
            props: true,
            name: 'dashboard.organisation.investments.clients.funds'
          }
        ]
      },
      {
        path: ':investmentId/funds/:fundId',
        component: FundInformationPage,
        props: true,
        name: 'dashboard.organisation.investments.clients.funds.info'
      }
    ]
  }
];
